<template>
  <div>
    <SectionHeader>
      <template v-slot:breadcrumbs>
        <BreadCrumbs
          :items="[{ text: $t('meta.costCenters'), name: 'cost_centers' }, { text: $t('costCenters.addCostCenter') }]"
        />
      </template>
    </SectionHeader>

    <div class="body-content cf">
      <CompanyNav />
      <div class="body">
        <div class="content-wrap">
          <header class="content-header cf">
            <h3>{{ $t('costCenters.addCostCenter') }}</h3>
          </header>
          <div class="content-body">
            <Form :value="costCenter" @submit="createCostCenter" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Form from '@/views/companies/cost_centers/Form'

import BreadCrumbs from '@/components/BreadCrumbs/index.vue'
import SectionHeader from '@/components/SectionHeader'
import CompanyNav from '@/components/company_nav'

import costCentersApi from '@/api/costCenters'

export default {
  name: 'new_cost_center',
  inject: ['companyUser'],
  components: {
    BreadCrumbs,
    CompanyNav,
    Form,
    SectionHeader,
  },
  data() {
    return {
      costCenter: {},
    }
  },
  methods: {
    async createCostCenter(costCenter) {
      const createdCostCenter = await costCentersApi.create({
        ...costCenter,
        company_uuid: this.companyUser.company_uuid,
      })

      if (createdCostCenter) await this.$router.push(`/company/cost_centers`)
    },
  },
}
</script>
